import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Breadcrumb, BreadcrumbItem, Button, Card, Col, Container, Fa, Nav, NavItem, Row} from "mdbreact";
import {Link, NavLink} from "react-router-dom";
import validator from 'validator';
import axios from "axios";
import qs from 'qs';
import {LangValidation} from "./../../lang/fa/validation";

import {Alert} from "reactstrap";
import {setUser} from "./../../redux/actions/user";
import {API_URL} from "./../../config/Config";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItemPills: '1',
            fields: {
                username:'',
                password: '',
            },
            errors: {},
            hasAlert:false,
        };

    }

    handleValidation(callback) {
        let {fields} = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.username)) {
            formIsValid = false;
            errors["username"] = LangValidation.required;
        }else if (!validator.isLength(fields.username, {min: 5, max: undefined})) {
            formIsValid = false;
            errors["username"] = LangValidation.min;
        }

        if (validator.isEmpty(fields.password)) {
            formIsValid = false;
            errors["password"] = LangValidation.required;
        }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
            formIsValid = false;
            errors["password"] = LangValidation.min;
        }

        this.setState({errors}, () => {
            return callback(formIsValid)
        });

    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'password':
                if (validator.isEmpty(fields.password)) {
                    errors["password"] = LangValidation.required;
                }else if (!validator.isLength(fields.password, {min: 6, max: undefined})) {
                    errors["password"] = LangValidation.min;
                }
                break;
            case 'username':
                if (validator.isEmpty(fields.username)) {
                    errors["username"] = LangValidation.required;
                }else if (!validator.isLength(fields.username, {min: 5, max: undefined})) {
                    errors["username"] = LangValidation.min;
                }
                break;
            default:

        }
        this.setState({
            fields,errors
        });

    }

    checkStatus(response) {
        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
        return response.data;
    }

    handleRequest=()=> {
        const { password, username} = this.state.fields;
        const data = { password, username};
        let errors = {};
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url:`${API_URL}login`,
        };
        // axios.post(`${API_URL}login`, data)
        axios(options)
            .then(
                this.checkStatus
            ).then(json => {
            this.props.setUser(json.data);

            this.props.history.push('/');
        })
            .catch(error => {
                const response = error.response;
                if (response === undefined) {
                    console.log(error);
                } else {
                    for (var key in response.data) {
                        if (response.data.hasOwnProperty(key)) {
                            errors[key] = response.data[key];
                        }
                    }
                }
                this.setState({hasAlert:true, errors});
            });

    };

    handleLogin(event) {
        event.preventDefault();
        this.handleValidation((valid) => {
            if (valid) this.handleRequest();
        });
    }

    render() {
        const { password, username} = this.state.fields;
        const {errors} = this.state;


        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem active> ورود کاربر</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="container rtl" style={{marginTop: 100, marginBottom: 150}}>
                        <div className="row">
                            <div className="col-md-6 " style={{float: "none", margin: "0 auto"}}>
                                <Card style={{padding:20}}>

                                    <div className="card-header1 mb-2">
                                        <Nav pills color="secondary" className="nav-justified mt-2">
                                            <NavItem>
                                                <Button to="/login" className="btn btn-default btn-block">
                                                    ورود کاربر
                                                </Button>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink to="/register" className="btn btn-link">
                                                    ثبت نام در سامانه
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <hr/>
                                        <Row>
                                            <Col md="12">
                                                {this.state.hasAlert?
                                                    <Alert color="danger">
                                                        خطایی در هنگام ثبت اطلاعات رخ داد.
                                                    </Alert>
                                                    :""}
                                            </Col>
                                        </Row>
                                        <form>
                                            <Row>

                                                <Col md="12" sm="12">
                                                    <div className="md-form input-group">
                                                        <span className="input-group-addon p-2">
                                                            <i className="fa fa-user grey-text mt-3"
                                                               style={{fontSize: 20}}/>
                                                        </span>
                                                        <input type="text"
                                                               placeholder="نام کاربری"
                                                               className={errors["username"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="username"
                                                               value={username}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["username"]?<div className="invalid-feedback" >{errors["username"]}</div>:""}

                                                    </div>
                                                    <div className="md-form input-group">
                                                        <span className="input-group-addon p-2">
                                                            <i className="fa fa-key grey-text mt-3" style={{fontSize: 20}}/>
                                                        </span>
                                                        <input type="password"
                                                               placeholder="رمز عبور"
                                                               className={errors["password"]?"form-control is-invalid":"form-control"}
                                                               autoComplete="off"
                                                               name="password"
                                                               value={password}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        {errors["password"]?<div className="invalid-feedback" >{errors["password"]}</div>:""}

                                                    </div>
                                                    
                                                    <div className="text-center mt-5">
                                                        <Button color="default" block onClick={this.handleLogin.bind(this)} className="mb-4 mt-4">
                                                            ثبت <Fa icon="paper-plane-o white-text" className="ml-1"/>
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser : user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/auth/Login.js